import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerTcfVendor } from "./vendor.js";
import { useBanner } from "../../../../contexts/banner.js";
import { useTcfVendors } from "../../../../hooks/tcf/useTcfVendors.js";
import { Group } from "../../../common/groups/group.js";
const BannerTcfVendorList = ()=>{
    const banner = useBanner();
    const { tcfFilterBy, i18n: { tcf: { vendors, filterNoVendors } } } = banner;
    const useVendors = useTcfVendors(tcfFilterBy);
    const hasVendors = useVendors.length > 0;
    return /*#__PURE__*/ _jsxs(Group, {
        headline: vendors,
        children: [
            useVendors.map((param)=>{
                let { id } = param;
                return /*#__PURE__*/ _jsx(BannerTcfVendor, {
                    id: id
                }, id);
            }),
            !hasVendors && filterNoVendors
        ]
    });
};
export { BannerTcfVendorList };
